import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CustomHttpParamEncoder } from '../../../util/customhttpparamencoder';
import { API_ENDPOINT } from '../tokens/api.token';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(
    private http: HttpClient,
    @Inject(API_ENDPOINT) private baseUrl: string,
  ) {}

  get<T>(path: string, params?: Record<string, any>) {
    return this.http.get<T>(this.buildUrl(path), { params });
  }

  post<T>(path: string, body?: any, params?: Record<string, any>) {
    return this.http.post<T>(this.buildUrl(path), body ?? null, {
      params: params
        ? new HttpParams({
            fromObject: params,
            encoder: new CustomHttpParamEncoder(),
          })
        : undefined,
    });
  }

  put<T>(path: string, body?: any, params?: Record<string, any>) {
    return this.http.put<T>(this.buildUrl(path), body ?? null, {
      params: params
        ? new HttpParams({
            fromObject: params,
            encoder: new CustomHttpParamEncoder(),
          })
        : undefined,
    });
  }

  delete<T>(path: string, params?: Record<string, any>) {
    return this.http.delete<T>(this.buildUrl(path), {
      params: params
        ? new HttpParams({
            fromObject: params,
            encoder: new CustomHttpParamEncoder(),
          })
        : undefined,
    });
  }

  deleteWithBody<T>(path: string, body?: any) {
    return this.http.delete<T>(this.buildUrl(path), { body });
  }

  one(resource: string, id: string | number) {
    const base = `${resource}/${id}`;

    return {
      get: <T>(params?: any) => this.get<T>(base, params),
      put: <T>(body?: any, params?: any) => this.put<T>(base, body, params),
      delete: <T>(params?: any) => this.delete<T>(base, params),
      deleteWithBody: <T>(body?: any) => this.deleteWithBody<T>(base, body),
      post: <T>(body?: any, params?: any) => this.post<T>(base, body, params),
    };
  }

  all(resource: string) {
    return {
      get: <T>(params?: any) => this.get<T>(resource, params),
      put: <T>(body?: any, params?: any) => this.put<T>(resource, body, params),
      post: <T>(body?: any, params?: any) =>
        this.post<T>(resource, body, params),
      delete: <T>(params?: any) => this.delete<T>(resource, params),
      deleteWithBody: <T>(body?: any) =>
        this.deleteWithBody<T>(resource, body),
    };
  }

  private buildUrl(path: string) {
    return `${this.baseUrl}/${path}`;
  }
}
